// export const schoolID = "4C6B9694-2954-4CD6-A815-0467DA5B622B";

export const Roles = [
  {
    RoleName: 'Admin',
  },
  {
    RoleName: 'Student',
  },
  {
    RoleName: 'Employee',
  },
  {
    RoleName: 'Parent',
  },
  {
    RoleName: 'Teacher',
  },
  {
    RoleName: 'Director',
  },
   {
    RoleName: 'SuperDirector',
  },
  {
    RoleName: 'Principal',
  },
];

export const ActionForTransportManagement = {
  GETALL : "GETALL" ,
  INSERT : "INSERT",
  UPDATE : "UPDATE",
  DELETE : "DELETE",
  GETBYSTUDENT : "GETBYSTUDENT",
  GETBYVEHICLE : "GETBYVEHICLE ",
}

export const GETACTION = "GET";

export const BIOMETRIC_ACTIONS = {
  REGISTER: "REGISTER",
  UPDATE: "UPDATE",
  REVOKE: "REVOKE",
}


export const myDashboard = "My Dashboard";

export const StudentDataTab = "STUDENT DATA";
export const StaffDataTab = "STAFF DATA";
export const FeesDataTab = "FEES DATA";

export const mockStudents = [
    {
        studentID: '1',
        student: {
            studentID: '1',
            fullName: 'Aarav Sharma',
            registrationNumber: 'REG001',
            acedminYear: '2024-25',
            feesFrequencyName: 'Quarterly',
            fatherName: 'Rajesh Sharma',
            motherName: 'Sunita Sharma',
            dob: '2010-05-15',
            address: 'Flat 12, Shanti Nagar, Jaipur, Rajasthan',
            phone: '+91 98765 43210',
        },
        classDetails: [
            {
                classID: '1',
                sectionID: '1',
                className: '10th',
                sectionName: 'A',
                classTeacher: 'Mrs. Kavita Mehta',
            },
        ],
        isPaid: true,
        paidAmount: 25000,
        totalAmount: 25000,
        feeStatus: 'Paid',
        feeBreakdown: [
            { type: 'Tuition Fee', amount: 15000, status: 'Paid' },
            { type: 'Library Fee', amount: 2000, status: 'Paid' },
            { type: 'Sports Fee', amount: 3000, status: 'Paid' },
            { type: 'Transport Fee', amount: 5000, status: 'Paid' },
        ],
        lastPaymentDate: '2024-01-15',
    },
    {
        studentID: '2',
        student: {
            studentID: '2',
            fullName: 'Ananya Verma',
            registrationNumber: 'REG002',
            acedminYear: '2024-25',
            feesFrequencyName: 'Monthly',
            fatherName: 'Amit Verma',
            motherName: 'Neha Verma',
            dob: '2011-08-22',
            address: 'House No. 45, Civil Lines, Prayagraj, UP',
            phone: '+91 91234 56789',
        },
        classDetails: [
            {
                classID: '2',
                sectionID: '2',
                className: '9th',
                sectionName: 'B',
                classTeacher: 'Mr. Suresh Gupta',
            },
        ],
        isPaid: false,
        paidAmount: 10000,
        totalAmount: 20000,
        feeStatus: 'Unpaid',
        feeBreakdown: [
            { type: 'Tuition Fee', amount: 12000, status: 'Paid' },
            { type: 'Library Fee', amount: 2000, status: 'Unpaid' },
            { type: 'Sports Fee', amount: 3000, status: 'Paid' },
            { type: 'Transport Fee', amount: 3000, status: 'Unpaid' },
        ],
        lastPaymentDate: '2024-01-10',
    },
    {
        studentID: '3',
        student: {
            studentID: '3',
            fullName: 'Rohit Singh',
            registrationNumber: 'REG003',
            acedminYear: '2024-25',
            feesFrequencyName: 'Yearly',
            fatherName: 'Mahendra Singh',
            motherName: 'Kavita Singh',
            dob: '2010-11-30',
            address: 'Village Kheda, Tehsil Kotputli, Rajasthan',
            phone: '+91 99887 66554',
        },
        classDetails: [
            {
                classID: '1',
                sectionID: '3',
                className: '10th',
                sectionName: 'C',
                classTeacher: 'Ms. Pooja Rathore',
            },
        ],
        isPaid: false,
        paidAmount: 0,
        totalAmount: 30000,
        feeStatus: 'Unpaid',
        feeBreakdown: [
            { type: 'Tuition Fee', amount: 20000, status: 'Unpaid' },
            { type: 'Library Fee', amount: 3000, status: 'Unpaid' },
            { type: 'Sports Fee', amount: 4000, status: 'Unpaid' },
            { type: 'Transport Fee', amount: 3000, status: 'Unpaid' },
        ],
        lastPaymentDate: null,
    },
    {
        studentID: '4',
        student: {
            studentID: '4',
            fullName: 'Pooja Patel',
            registrationNumber: 'REG004',
            acedminYear: '2024-25',
            feesFrequencyName: 'Half-Yearly',
            fatherName: 'Kiran Patel',
            motherName: 'Rekha Patel',
            dob: '2012-03-10',
            address: 'B-204, Satellite Area, Ahmedabad, Gujarat',
            phone: '+91 90123 45678',
        },
        classDetails: [
            {
                classID: '3',
                sectionID: '1',
                className: '8th',
                sectionName: 'A',
                classTeacher: 'Mr. Harish Solanki',
            },
        ],
        isPaid: true,
        paidAmount: 18000,
        totalAmount: 18000,
        feeStatus: 'Paid',
        feeBreakdown: [
            { type: 'Tuition Fee', amount: 10000, status: 'Paid' },
            { type: 'Library Fee', amount: 2000, status: 'Paid' },
            { type: 'Sports Fee', amount: 3000, status: 'Paid' },
            { type: 'Transport Fee', amount: 3000, status: 'Paid' },
        ],
        lastPaymentDate: '2024-01-20',
    },
    {
        studentID: '5',
        student: {
            studentID: '5',
            fullName: 'Aditya Mishra',
            registrationNumber: 'REG005',
            acedminYear: '2024-25',
            feesFrequencyName: 'Quarterly',
            fatherName: 'Sanjay Mishra',
            motherName: 'Renu Mishra',
            dob: '2011-12-05',
            address: 'Near Hanuman Mandir, Rewa, Madhya Pradesh',
            phone: '+91 88990 11223',
        },
        classDetails: [
            {
                classID: '2',
                sectionID: '2',
                className: '9th',
                sectionName: 'B',
                classTeacher: 'Mrs. Nidhi Tiwari',
            },
        ],
        isPaid: false,
        paidAmount: 5000,
        totalAmount: 15000,
        feeStatus: 'Partially Paid',
        feeBreakdown: [
            { type: 'Tuition Fee', amount: 8000, status: 'Paid' },
            { type: 'Library Fee', amount: 2000, status: 'Unpaid' },
            { type: 'Sports Fee', amount: 3000, status: 'Unpaid' },
            { type: 'Transport Fee', amount: 2000, status: 'Unpaid' },
        ],
        lastPaymentDate: '2024-01-05',
    },
];
export const MaxPageSize = 9999;
export const MasterTableWithTC = true;

export const PaymentMovedStudent = "Wallet";